
/* styles */
require("!!../../../../node_modules/extract-text-webpack-plugin/loader.js?{\"omit\":1,\"remove\":true}!vue-style-loader!css-loader?sourceMap!../../../../node_modules/vue-loader/lib/style-rewriter?id=data-v-7a3b2e4d&scoped=true!../css/modalFormExibirNotificacao.css")

var Component = require("!../../../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../../../node_modules/vue-loader/lib/selector?type=script&index=0!./ModalFormExibirNotificacao.vue"),
  /* template */
  require("!!../../../../node_modules/vue-loader/lib/template-compiler?id=data-v-7a3b2e4d!../../../../node_modules/vue-loader/lib/selector?type=template&index=0!./ModalFormExibirNotificacao.vue"),
  /* scopeId */
  "data-v-7a3b2e4d",
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/components/notificacao/modal/ModalFormExibirNotificacao.vue
// module id = 907
// module chunks = 1